/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x4cde0a from'./../../message.js';class GetDocumentThreadsMessage extends _0x4cde0a{constructor(_0x5c7cff){super(),this['documentId']=_0x5c7cff;}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x152d42){return new GetDocumentThreadsMessage(_0x152d42['documentId']);}}GetDocumentThreadsMessage['TYPE']='94',GetDocumentThreadsMessage['READABLE_TYPE_NAME']='getDocumentThreads',GetDocumentThreadsMessage['DESCRIPTOR_NAME']='CommentsV2GetDocumentThreadsMessage',GetDocumentThreadsMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1}}};export default GetDocumentThreadsMessage;